module.exports = __webpack_public_path__ + "static/media/file-upload.e855146d.svg";